var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.735 12.8572C6.55446 12.6651 6.30541 12.5522 6.04201 12.5428C5.77861 12.5334 5.52217 12.6284 5.32844 12.8071C5.13471 12.9858 5.01937 13.2338 5.00749 13.4971C4.99561 13.7604 5.08815 14.0177 5.265 14.2132L8.877 18.1322C9.414 18.6582 10.214 18.6582 10.711 18.1622L11.075 17.8032C12.3895 16.5104 13.7025 15.216 15.014 13.9202L15.054 13.8802C16.2797 12.6722 17.499 11.4579 18.712 10.2372C18.8933 10.0474 18.9927 9.79389 18.9887 9.53145C18.9848 9.26902 18.8778 9.01865 18.6909 8.83437C18.504 8.6501 18.2522 8.54669 17.9897 8.54646C17.7273 8.54624 17.4752 8.64921 17.288 8.83316C16.0807 10.0475 14.8673 11.2558 13.648 12.4582L13.608 12.4982C12.3513 13.7405 11.0929 14.9811 9.833 16.2202L6.735 12.8572Z",
    fill: "#0747A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6d2a8827.svg";
export { ForwardRef as ReactComponent };